"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/esnext.json.parse.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var _loop = require("@/api/loop");
var _hike = require("@/api/hike");
var _user = require("@/api/user");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionEdit',
  data() {
    return {
      activeTab: 'info',
      loggedInUserTenants: [],
      fullscreenloading: false,
      dialogLoopVisible: false,
      loopTableLoading: false,
      dialogCoachVisible: false,
      coachTableLoading: false,
      organizations: [],
      loopList: [],
      loopTotal: 0,
      loopQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      coachList: [],
      coachTotal: 0,
      coachQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      form: {
        id: '',
        tenant: '',
        organization: '',
        title: '',
        startDate: '',
        endDate: '',
        status: 'Published',
        loops: [],
        coaches: [],
        sessionsPerUser: 0,
        overallQuota: 0,
        expiryDate: '',
        performance: {
          checkinPassingRate: 80,
          minimumStepCount: 0
        }
      },
      savedForm: null,
      initialSessionsPerUser: 0,
      updateCount: 0,
      allSubscriptions: [],
      userRecordsList: [],
      userRecordsStats: null,
      userRecordsTotal: 0,
      userRecordsLoading: false,
      userRecordsQuery: {
        page: 1,
        limit: 10,
        search: ''
      },
      dialogChangelogVisible: false,
      selectedUserChangelog: [],
      selectedUserName: '',
      dialogBookingsVisible: false,
      bookingsLoading: false,
      bookingsList: [],
      coachMap: {},
      dialogMandatoryActivitiesVisible: false,
      selectedUserMandatoryActivities: [],
      quotaType: 'unlimited',
      limitedQuotaValue: 1000
    };
  },
  computed: {
    totalCheckinStageCount() {
      if (!this.userRecordsStats) return 0;
      const hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalCheckinStageCount !== undefined && hikesInfo.totalCheckinStageCount !== null) {
        return Number(hikesInfo.totalCheckinStageCount);
      }
      return 0;
    },
    totalStepCount() {
      if (!this.userRecordsStats) return 0;
      const hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalStepCount !== undefined && hikesInfo.totalStepCount !== null) {
        return Number(hikesInfo.totalStepCount);
      }
      return 0;
    },
    totalMandatoryHikeActivityCount() {
      if (!this.userRecordsStats) return this.mandatoryHikeActivities ? this.mandatoryHikeActivities.length : 0;
      const hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalMandatoryHikeActivityCount !== undefined && hikesInfo.totalMandatoryHikeActivityCount !== null) {
        return Number(hikesInfo.totalMandatoryHikeActivityCount);
      }
      if (hikesInfo && hikesInfo.mandatoryHikeActivityCount !== undefined && hikesInfo.mandatoryHikeActivityCount !== null) {
        return Number(hikesInfo.mandatoryHikeActivityCount);
      }
      return this.mandatoryHikeActivities ? this.mandatoryHikeActivities.length : 0;
    },
    mandatoryHikeActivities() {
      if (!this.form || !Array.isArray(this.form.loops)) return [];
      const activities = [];
      const seenKeys = new Set();
      this.form.loops.forEach(loop => {
        if (Array.isArray(loop.hikes)) {
          loop.hikes.forEach(hike => {
            if (Array.isArray(hike.mandatoryActivities)) {
              hike.mandatoryActivities.forEach(item => {
                const uniqueKey = `${item.hikeId}_${item.actionId || item.displayText}`;
                if (!seenKeys.has(uniqueKey)) {
                  seenKeys.add(uniqueKey);
                  activities.push(item);
                }
              });
            }
          });
        }
      });
      return activities;
    }
  },
  watch: {
    '$route.hash': {
      handler(hash) {
        if (hash === '#user-records') {
          this.activeTab = 'user-records';
        }
      },
      immediate: true
    }
  },
  created() {
    this.getOrganizationsList();
    this.getLoggedInUserTenants();
    this.loadSubscription();
    this.loadUserRecords();
    this.loadUserRecordsStatistics();
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    handleQuotaTypeChange(type) {
      if (type === 'unlimited') {
        this.form.overallQuota = 0;
      } else if (type === 'limited') {
        if (!this.limitedQuotaValue || Number(this.limitedQuotaValue) <= 0) {
          this.limitedQuotaValue = 1000;
        }
        this.form.overallQuota = Number(this.limitedQuotaValue);
      }
    },
    handleLimitedQuotaChange(val) {
      const num = Number(val);
      this.limitedQuotaValue = num > 0 ? num : 1000;
      this.form.overallQuota = this.limitedQuotaValue;
    },
    getLoggedInUserTenants() {
      if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
        this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
      } else {
        this.loggedInUserTenants = [Constants.TENANT_LIFEHIKES, Constants.TENANT_LIFEHIKES_FOUNDATION];
      }
    },
    getOrganizationsList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.getAllOrganizations)(token).then(response => {
        if (response.data && response.data.rows) {
          this.organizations = response.data.rows.map(org => ({
            id: org.id,
            name: org.name
          }));
        }
      }).catch(error => {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
      });
    },
    loadSubscription() {
      const subId = this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token && subId) {
        this.fullscreenloading = true;
        (0, _subscriptions.getSubscriptionById)(token, subId).then(response => {
          const subData = response.data;
          const form = {
            id: subData.id,
            tenant: subData.metadata ? subData.metadata.tenant : '',
            organization: subData.organizationId,
            title: subData.title,
            startDate: subData.startDate ? subData.startDate.substring(0, 10) : '',
            endDate: subData.endDate ? subData.endDate.substring(0, 10) : '',
            status: subData.status ? subData.status.charAt(0).toUpperCase() + subData.status.slice(1) : 'Published',
            loops: [],
            coaches: [],
            sessionsPerUser: 0,
            overallQuota: 0,
            expiryDate: '',
            performance: {
              checkinPassingRate: (subData.userPerformance || subData.performance) && (subData.userPerformance || subData.performance).checkinPassingRate !== undefined && (subData.userPerformance || subData.performance).checkinPassingRate !== null ? Math.round((subData.userPerformance || subData.performance).checkinPassingRate * 100) : 80,
              minimumStepCount: (subData.userPerformance || subData.performance) && (subData.userPerformance || subData.performance).minimumStepCount !== undefined && (subData.userPerformance || subData.performance).minimumStepCount !== null ? (subData.userPerformance || subData.performance).minimumStepCount : 0
            }
          };
          if (subData.individualCoaching) {
            form.sessionsPerUser = subData.individualCoaching.maxSessionsPerUser !== undefined && subData.individualCoaching.maxSessionsPerUser !== null ? subData.individualCoaching.maxSessionsPerUser : 0;
            form.overallQuota = subData.individualCoaching.overallSessionQuota || 0;
            const bookingExpiry = subData.individualCoaching.bookingExpiry;
            if (typeof bookingExpiry === 'string') {
              form.expiryDate = bookingExpiry.substring(0, 10);
            }
          }
          const orgPromise = (0, _organizations.getAllOrganizations)(token).then(orgResponse => {
            if (orgResponse.data && orgResponse.data.rows) {
              const org = orgResponse.data.rows.find(o => o.id === subData.organizationId);
              if (org) {
                form.organization = org.name;
              }
            }
          }).catch(err => {
            (0, _log.showDebugLog)('org-lookup-error', err);
          });
          const loopPromise = this.fetchSubscriptionLoops(token, subData.relatedPrograms).then(loops => {
            form.loops = loops;
          });
          const coachPromises = [];
          if (subData.coaches) {
            const validCoaches = subData.coaches.filter(coach => coach.userUuid);
            form.coaches = new Array(validCoaches.length);
            validCoaches.forEach((coach, index) => {
              const p = (0, _user.getUser)(token, coach.userUuid).then(userRes => {
                const userData = userRes.data;
                form.coaches[index] = {
                  uuid: coach.userUuid,
                  givenName: userData.givenName || '',
                  familyName: userData.familyName || '',
                  email: userData.email || '',
                  calendlyLink: coach.calendlyEventTypeLinkWithSlug || coach.calendlyEventTypeLink || '',
                  calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
                  enabled: typeof coach.isEnabled === 'boolean' ? coach.isEnabled : true
                };
              }).catch(err => {
                (0, _log.showDebugLog)('coach-user-error', err);
                form.coaches[index] = {
                  uuid: coach.userUuid,
                  givenName: 'Coach',
                  familyName: coach.userUuid.substring(0, 8),
                  email: '',
                  calendlyLink: coach.calendlyEventTypeLinkWithSlug || coach.calendlyEventTypeLink || '',
                  calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
                  enabled: typeof coach.isEnabled === 'boolean' ? coach.isEnabled : true
                };
              });
              coachPromises.push(p);
            });
          }
          return Promise.all([orgPromise, loopPromise, ...coachPromises]).then(() => {
            form.coaches = form.coaches.filter(Boolean);
            this.form = form;
            this.initialSessionsPerUser = form.sessionsPerUser;
            this.updateCount = subData.updateCount || 0;
            if (Number(form.overallQuota) > 0) {
              this.quotaType = 'limited';
              this.limitedQuotaValue = Number(form.overallQuota);
            } else {
              this.quotaType = 'unlimited';
              this.limitedQuotaValue = 1000;
            }
            this.savedForm = _lodash.default.cloneDeep(this.form);
            this.fullscreenloading = false;
            this.loadUserRecordsStatistics();
          });
        }).catch(error => {
          (0, _log.showDebugLog)('getSubscriptionById-error', error);
          this.fullscreenloading = false;
        });
      }
    },
    openLoopDialog() {
      this.dialogLoopVisible = true;
      this.searchLoops();
    },
    searchLoops() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loopTableLoading = true;
      const queryParams = {
        tenants: this.form.tenant,
        page: this.loopQuery.page,
        limit: this.loopQuery.limit
      };
      if (this.loopQuery.q) {
        queryParams.q = this.loopQuery.q;
      }
      if (token) {
        (0, _loop.getLoopList)(token, queryParams).then(response => {
          this.loopList = response.data.rows;
          this.loopTotal = response.data.count;
          this.loopTableLoading = false;
        }).catch(error => {
          (0, _log.showDebugLog)('getLoopList-error', error);
        });
      }
    },
    async fetchSubscriptionLoops(token, relatedPrograms) {
      if (!Array.isArray(relatedPrograms)) {
        return [];
      }
      const loopPrograms = relatedPrograms.filter(program => program && program.programType === 'Loop' && program.programId);
      const loops = new Array(loopPrograms.length);
      const loopPromises = loopPrograms.map((program, index) => {
        return (0, _loop.getLoopById)(token, program.programId).then(loopRes => {
          const loopData = loopRes.data;
          return this.fetchLoopHikes(token, loopData).then(hikes => {
            loops[index] = {
              id: loopData.id,
              title: loopData.title,
              hikes: hikes
            };
          });
        }).catch(err => {
          (0, _log.showDebugLog)('loop-details-error', err);
          loops[index] = {
            id: program.programId,
            title: 'Loop: ' + program.programId,
            hikes: []
          };
        });
      });
      await Promise.all(loopPromises);
      return loops.filter(Boolean);
    },
    async fetchLoopHikes(token, loopData) {
      const hikes = [];
      if (loopData && Array.isArray(loopData.programs)) {
        const hikePromises = [];
        loopData.programs.forEach(program => {
          if (program && program.type === 'enrollment' && Array.isArray(program.options)) {
            program.options.forEach(option => {
              if (option && option.objectType === 'hike' && option.objectId) {
                const hikeId = option.objectId;
                const p = (0, _hike.getHikeById)(token, hikeId).then(hikeRes => {
                  const hikeData = hikeRes.data || {};
                  const hikeTitle = hikeData.title || option.objectData && option.objectData.title || option.title || 'Untitled Hike';
                  const mandatoryActivities = [];
                  if (Array.isArray(hikeData.stages)) {
                    hikeData.stages.forEach((stage, stageIndex) => {
                      const stageTitle = stage.title || 'Stage ' + (stageIndex + 1);
                      if (Array.isArray(stage.actionSets)) {
                        stage.actionSets.forEach((actionSet, actionSetIndex) => {
                          const actionSetTitle = actionSet.type || actionSet.title || 'Activity ' + (actionSetIndex + 1);
                          if (Array.isArray(actionSet.actions)) {
                            actionSet.actions.forEach((action, actionIndex) => {
                              if (action && (action.isSubscriptionIndividualCoachingMandatoryActivity === true || action.isSubscriptionIndividualCoachingMandatoryActivity === 'true')) {
                                const actionTitle = action.title || 'Component ' + (actionIndex + 1);
                                mandatoryActivities.push({
                                  hikeId: hikeId,
                                  hikeTitle: hikeTitle,
                                  stageTitle: stageTitle,
                                  activityTitle: actionSetTitle,
                                  componentTitle: actionTitle,
                                  actionId: action.id || action._id,
                                  key: `${hikeId}_${stage.id || stageIndex}_${actionSet.id || actionSetIndex}_${action.id || actionIndex}`,
                                  displayText: `${hikeTitle} > ${stageTitle} > ${actionSetTitle} > ${actionTitle}`
                                });
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                  hikes.push({
                    id: hikeId,
                    title: hikeTitle,
                    mandatoryActivities: mandatoryActivities
                  });
                }).catch(err => {
                  (0, _log.showDebugLog)('getHikeById-error', err);
                  hikes.push({
                    id: hikeId,
                    title: option.objectData && option.objectData.title || option.title || 'Untitled Hike',
                    mandatoryActivities: []
                  });
                });
                hikePromises.push(p);
              }
            });
          }
        });
        await Promise.all(hikePromises);
      }
      return hikes;
    },
    addLoop(row) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (this.form.loops.some(loop => loop.id === row.id)) {
        (0, _log.displayPopupMessage)('This loop has already been added.', 'warning');
        this.dialogLoopVisible = false;
        return;
      }
      this.fullscreenloading = true;
      if (token) {
        (0, _loop.getLoopById)(token, row.id).then(response => {
          const loopData = response.data;
          return this.fetchLoopHikes(token, loopData).then(hikes => {
            this.form.loops.push({
              id: loopData.id,
              title: loopData.title,
              hikes: hikes
            });
            this.fullscreenloading = false;
            this.dialogLoopVisible = false;
          });
        }).catch(error => {
          (0, _log.showDebugLog)('getLoopById-error', error);
          this.fullscreenloading = false;
        });
      } else {
        this.fullscreenloading = false;
      }
    },
    removeLoop(index) {
      this.form.loops.splice(index, 1);
    },
    handleLoopSizeChange(val) {
      this.loopQuery.limit = val;
      this.searchLoops();
    },
    handleLoopCurrentChange(val) {
      this.loopQuery.page = val;
      this.searchLoops();
    },
    openCoachDialog() {
      this.dialogCoachVisible = true;
      this.searchCoaches();
    },
    searchCoaches() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.coachTableLoading = true;
      const queryParams = {
        page: this.coachQuery.page,
        limit: this.coachQuery.limit,
        role: Constants.USER_ROLE_OTR_COACH
      };
      if (this.coachQuery.q) {
        queryParams.q = this.coachQuery.q;
      }
      if (token) {
        (0, _user.getUserList)(token, queryParams).then(response => {
          this.coachList = response.data.rows;
          this.coachTotal = response.data.count;
          this.coachTableLoading = false;
        }).catch(error => {
          (0, _log.showDebugLog)('getUserList-error', error);
        });
      }
    },
    addCoach(row) {
      if (this.form.coaches.some(c => c.uuid === row.uuid)) {
        (0, _log.displayPopupMessage)('This coach has already been added.', 'warning');
        this.dialogCoachVisible = false;
        return;
      }
      this.form.coaches.push({
        uuid: row.uuid,
        givenName: row.givenName,
        familyName: row.familyName,
        email: row.email,
        calendlyLink: '',
        calendlyEventTypeLink: '',
        enabled: true
      });
      this.dialogCoachVisible = false;
      (0, _log.displayPopupMessage)('Coach added successfully.', 'success');
    },
    removeCoach(index) {
      this.$confirm('Are you sure you want to remove this coach?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.form.coaches.splice(index, 1);
        (0, _log.displayPopupMessage)('Coach removed.', 'success');
      }).catch(() => {});
    },
    moveCoachUp(index) {
      if (index > 0) {
        const temp = this.form.coaches[index];
        this.$set(this.form.coaches, index, this.form.coaches[index - 1]);
        this.$set(this.form.coaches, index - 1, temp);
      }
    },
    moveCoachDown(index) {
      if (index < this.form.coaches.length - 1) {
        const temp = this.form.coaches[index];
        this.$set(this.form.coaches, index, this.form.coaches[index + 1]);
        this.$set(this.form.coaches, index + 1, temp);
      }
    },
    handleCoachSizeChange(val) {
      this.coachQuery.limit = val;
      this.searchCoaches();
    },
    handleCoachCurrentChange(val) {
      this.coachQuery.page = val;
      this.searchCoaches();
    },
    doSave() {
      if (!this.form.title) {
        (0, _log.displayPopupMessage)('Subscription Title is required.', 'error');
        return;
      }
      if (!this.form.startDate) {
        (0, _log.displayPopupMessage)('Start date is required.', 'error');
        return;
      }
      if (!this.form.endDate) {
        (0, _log.displayPopupMessage)('End date is required.', 'error');
        return;
      }
      if (new Date(this.form.endDate) < new Date(this.form.startDate)) {
        (0, _log.displayPopupMessage)('End date cannot be earlier than start date.', 'error');
        return;
      }
      if (this.updateCount > 0 && this.form.sessionsPerUser < this.initialSessionsPerUser) {
        (0, _log.displayPopupMessage)(`Number of sessions per user cannot be less than the previous setting of ${this.initialSessionsPerUser} as it will affect the current bookings.`, 'error');
        return;
      }
      if (Number(this.form.overallQuota) !== 0 && Number(this.form.overallQuota) < Number(this.form.sessionsPerUser)) {
        (0, _log.displayPopupMessage)('Total session quota must be 0 or equal or greater than Number of sessions per user.', 'error');
        return;
      }

      // Check that all coaches have a Calendly link
      for (const coach of this.form.coaches) {
        if (!coach.calendlyLink || !coach.calendlyLink.trim()) {
          (0, _log.displayPopupMessage)(`Calendly Event Type Link is required for coach ${coach.givenName} ${coach.familyName}.`, 'error');
          return;
        }
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token && this.form.id) {
        const org = this.organizations.find(o => o.name === this.form.organization);
        const organizationId = org ? org.id : this.form.organization;
        const payload = {
          metadata: {
            tenant: this.form.tenant
          },
          organizationId: organizationId,
          title: this.form.title,
          startDate: this.form.startDate ? new Date(this.form.startDate + 'T00:00:00.000Z').toISOString() : null,
          endDate: this.form.endDate ? new Date(this.form.endDate + 'T23:59:59.000Z').toISOString() : null,
          relatedPrograms: this.form.loops.map(loop => ({
            programType: 'Loop',
            programId: loop.id
          })),
          userPerformance: {
            checkinPassingRate: this.form.performance && this.form.performance.checkinPassingRate !== null && this.form.performance.checkinPassingRate !== undefined ? Number((Number(this.form.performance.checkinPassingRate) / 100).toFixed(4)) : 0.8,
            minimumStepCount: this.form.performance && this.form.performance.minimumStepCount !== null && this.form.performance.minimumStepCount !== undefined ? Number(this.form.performance.minimumStepCount) : 0
          },
          individualCoaching: {
            maxSessionsPerUser: this.form.sessionsPerUser,
            overallSessionQuota: this.form.overallQuota,
            bookingExpiry: this.form.expiryDate || null
          },
          coaches: this.form.coaches.map(coach => ({
            userUuid: coach.uuid,
            calendlyEventTypeLinkWithSlug: coach.calendlyLink,
            calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
            isEnabled: coach.enabled
          })),
          status: this.form.status ? this.form.status.toLowerCase() : 'published'
        };
        if (this.updateCount === 0) {
          this.$confirm(`Please confirm that "Number of sessions per user" is set correctly. It cannot be changed after this update.`, 'Warning', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.executeSave(token, payload);
          }).catch(() => {});
        } else {
          this.executeSave(token, payload);
        }
      }
    },
    executeSave(token, payload) {
      this.fullscreenloading = true;
      (0, _subscriptions.updateSubscription)(token, this.form.id, payload).then(response => {
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)('Subscription updated successfully.', 'success');
        this.updateCount += 1;
        this.initialSessionsPerUser = this.form.sessionsPerUser;
        this.savedForm = _lodash.default.cloneDeep(this.form);
      }).catch(error => {
        (0, _log.showDebugLog)('updateSubscription-api-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)('Failed to update subscription. ' + (error.message || ''), 'error');
      });
    },
    hasUnsavedChanges() {
      if (!this.savedForm) {
        return false;
      }
      return !_lodash.default.isEqual(this.form, this.savedForm);
    },
    async refreshSubscriptionLoopsAndHikes() {
      const subId = this.$route.params.id || this.form.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (!token || !subId) return;
      try {
        const response = await (0, _subscriptions.getSubscriptionById)(token, subId);
        const subData = response.data;
        if (subData && subData.relatedPrograms) {
          const loops = await this.fetchSubscriptionLoops(token, subData.relatedPrograms);
          this.form.loops = loops;
          if (this.savedForm) {
            this.savedForm.loops = _lodash.default.cloneDeep(loops);
          }
        }
      } catch (err) {
        (0, _log.showDebugLog)('refreshSubscriptionLoopsAndHikes-error', err);
      }
    },
    goBack() {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({
          path: '/subscriptions/index'
        });
      });
    },
    loadUserRecords() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const subId = this.$route.params.id || this.form.id;
      if (token && subId) {
        this.userRecordsLoading = true;
        const params = {
          page: this.userRecordsQuery.page,
          limit: this.userRecordsQuery.limit
        };
        if (this.userRecordsQuery.search && this.userRecordsQuery.search.trim()) {
          params.q = this.userRecordsQuery.search.trim();
        }
        (0, _subscriptions.getSubscriptionUserRecords)(token, subId, params).then(response => {
          if (response.data && response.data.rows) {
            this.userRecordsList = response.data.rows;
            this.userRecordsTotal = response.data.count || 0;
          } else {
            this.userRecordsList = [];
            this.userRecordsTotal = 0;
          }
          this.userRecordsLoading = false;
        }).catch(error => {
          (0, _log.showDebugLog)('getSubscriptionUserRecords-error', error);
          this.userRecordsLoading = false;
        });
        this.loadUserRecordsStatistics();
      }
    },
    async handleRefreshUserRecords() {
      if (this.hasUnsavedChanges()) {
        this.$alert('There are unsaved changes in the Subscription. Please save your changes before refreshing.', 'Warning', {
          confirmButtonText: 'OK',
          type: 'warning'
        }).catch(() => {});
        return;
      }
      this.userRecordsLoading = true;
      await this.refreshSubscriptionLoopsAndHikes();
      this.loadUserRecords();
    },
    async handleUserRecordsSearch() {
      if (this.hasUnsavedChanges()) {
        this.$alert('There are unsaved changes in the Subscription. Please save your changes before refreshing.', 'Warning', {
          confirmButtonText: 'OK',
          type: 'warning'
        }).catch(() => {});
        return;
      }
      this.userRecordsQuery.page = 1;
      this.userRecordsLoading = true;
      await this.refreshSubscriptionLoopsAndHikes();
      this.loadUserRecords();
    },
    handleUserRecordsSizeChange(val) {
      this.userRecordsQuery.limit = val;
      this.userRecordsQuery.page = 1;
      this.loadUserRecords();
    },
    handleUserRecordsCurrentChange(val) {
      this.userRecordsQuery.page = val;
      this.loadUserRecords();
    },
    viewUserChangelog(row) {
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.selectedUserChangelog = row.subscriptionRecord && row.subscriptionRecord.changelog || [];
      this.dialogChangelogVisible = true;
    },
    formatLogDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const pad = num => String(num).padStart(2, '0');
      const YYYY = date.getUTCFullYear();
      const MM = pad(date.getUTCMonth() + 1);
      const DD = pad(date.getUTCDate());
      const hh = pad(date.getUTCHours());
      const mm = pad(date.getUTCMinutes());
      const ss = pad(date.getUTCSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss} UTC`;
    },
    formatBeforeState(stateStr) {
      try {
        const parsed = JSON.parse(stateStr);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return stateStr;
      }
    },
    formatTargetCompletionRate(val) {
      if (val === undefined || val === null) return '';
      if (val > 0 && val <= 1) {
        return Math.round(val * 100) + '%';
      }
      return val + '%';
    },
    getStepCount(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.stepCount !== undefined && perf.stepCount !== null) {
        return perf.stepCount;
      }
      if (rec.stepCount !== undefined && rec.stepCount !== null) {
        return rec.stepCount;
      }
      if (row.stepCount !== undefined && row.stepCount !== null) {
        return row.stepCount;
      }
      if (perf && perf.stepTotal !== undefined && perf.stepTotal !== null) {
        return perf.stepTotal;
      }
      if (rec.stepTotal !== undefined && rec.stepTotal !== null) {
        return rec.stepTotal;
      }
      if (row.stepTotal !== undefined && row.stepTotal !== null) {
        return row.stepTotal;
      }
      if (rec.steps !== undefined && rec.steps !== null) {
        return rec.steps;
      }
      return 0;
    },
    getMaxStepCount(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.maxStepCount !== undefined && perf.maxStepCount !== null) {
        return perf.maxStepCount;
      }
      if (rec.maxStepCount !== undefined && rec.maxStepCount !== null) {
        return rec.maxStepCount;
      }
      if (row.maxStepCount !== undefined && row.maxStepCount !== null) {
        return row.maxStepCount;
      }
      if (perf && perf.maxStepTotal !== undefined && perf.maxStepTotal !== null) {
        return perf.maxStepTotal;
      }
      if (rec.maxStepTotal !== undefined && rec.maxStepTotal !== null) {
        return rec.maxStepTotal;
      }
      if (row.maxStepTotal !== undefined && row.maxStepTotal !== null) {
        return row.maxStepTotal;
      }
      return this.totalStepCount !== undefined && this.totalStepCount !== null ? this.totalStepCount : 0;
    },
    getStepTotal(row) {
      return this.getStepCount(row);
    },
    getMaxStepTotal(row) {
      return this.getMaxStepCount(row);
    },
    isStepCountPassing(row) {
      const stepCount = this.getStepCount(row);
      const minStepCount = this.form.performance && this.form.performance.minimumStepCount !== undefined && this.form.performance.minimumStepCount !== null ? Number(this.form.performance.minimumStepCount) : 0;
      return stepCount >= minStepCount;
    },
    getCheckinCount(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.checkinCount !== undefined && perf.checkinCount !== null) {
        return perf.checkinCount;
      }
      if (rec.checkinCount !== undefined && rec.checkinCount !== null) {
        return rec.checkinCount;
      }
      if (row.checkinCount !== undefined && row.checkinCount !== null) {
        return row.checkinCount;
      }
      if (perf && perf.checkinTotal !== undefined && perf.checkinTotal !== null) {
        return perf.checkinTotal;
      }
      if (rec.checkinTotal !== undefined && rec.checkinTotal !== null) {
        return rec.checkinTotal;
      }
      if (row.checkinTotal !== undefined && row.checkinTotal !== null) {
        return row.checkinTotal;
      }
      return 0;
    },
    getMaxCheckinCount(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.maxCheckinCount !== undefined && perf.maxCheckinCount !== null) {
        return perf.maxCheckinCount;
      }
      if (rec.maxCheckinCount !== undefined && rec.maxCheckinCount !== null) {
        return rec.maxCheckinCount;
      }
      if (row.maxCheckinCount !== undefined && row.maxCheckinCount !== null) {
        return row.maxCheckinCount;
      }
      if (perf && perf.maxCheckinTotal !== undefined && perf.maxCheckinTotal !== null) {
        return perf.maxCheckinTotal;
      }
      if (rec.maxCheckinTotal !== undefined && rec.maxCheckinTotal !== null) {
        return rec.maxCheckinTotal;
      }
      if (row.maxCheckinTotal !== undefined && row.maxCheckinTotal !== null) {
        return row.maxCheckinTotal;
      }
      return this.totalCheckinStageCount !== undefined && this.totalCheckinStageCount !== null ? this.totalCheckinStageCount : 0;
    },
    isCheckinCountPassing(row) {
      const checkinCount = this.getCheckinCount(row);
      const maxCheckin = this.getMaxCheckinCount(row);
      const passingRatePercent = this.form.performance && this.form.performance.checkinPassingRate !== undefined && this.form.performance.checkinPassingRate !== null ? Number(this.form.performance.checkinPassingRate) : 80;
      const checkinPassingRateFloat = passingRatePercent / 100;
      const requiredCheckins = maxCheckin * checkinPassingRateFloat;
      return checkinCount >= requiredCheckins;
    },
    getCheckinPercentage(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.checkinPercentage !== undefined && perf.checkinPercentage !== null) {
        return Math.round(Number(perf.checkinPercentage));
      }
      if (rec.checkinPercentage !== undefined && rec.checkinPercentage !== null) {
        return Math.round(Number(rec.checkinPercentage));
      }
      if (row.checkinPercentage !== undefined && row.checkinPercentage !== null) {
        return Math.round(Number(row.checkinPercentage));
      }
      const maxCount = this.getMaxCheckinCount(row);
      if (!maxCount || maxCount === 0) return 0;
      const count = this.getCheckinCount(row);
      return Math.round(count / maxCount * 100);
    },
    getCompletedMandatoryHikeActivityCount(row) {
      return _lodash.default.get(row, 'subscriptionRecord.performance.completedMandatoryHikeActivityCount', 0);
    },
    getMandatoryHikeActivityCount(row) {
      return _lodash.default.get(row, 'subscriptionRecord.performance.mandatoryHikeActivityCount', 0);
    },
    isMandatoryHikeActivityPassing(row) {
      const completed = this.getCompletedMandatoryHikeActivityCount(row);
      const total = this.getMandatoryHikeActivityCount(row);
      return completed >= total;
    },
    viewMandatoryActivities(row) {
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.selectedUserMandatoryActivities = this.getMandatoryActivitiesDetails(row);
      this.dialogMandatoryActivitiesVisible = true;
    },
    getMandatoryActivitiesDetails(row) {
      if (!this.mandatoryHikeActivities || this.mandatoryHikeActivities.length === 0) {
        return [];
      }
      const completedActivities = _lodash.default.get(row, 'subscriptionRecord.performance.mandatoryHikeActivities', []);
      return this.mandatoryHikeActivities.map(act => {
        const isCompleted = completedActivities.some(c => String(c.hikeId) === String(act.hikeId) && String(c.actionId) === String(act.actionId));
        return {
          ...act,
          isCompleted
        };
      });
    },
    getPassingCompletionRate(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      let val = null;
      if (perf && perf.passingCompletionRate !== undefined && perf.passingCompletionRate !== null) {
        val = perf.passingCompletionRate;
      } else if (rec.passingCompletionRate !== undefined && rec.passingCompletionRate !== null) {
        val = rec.passingCompletionRate;
      } else if (row.passingCompletionRate !== undefined && row.passingCompletionRate !== null) {
        val = row.passingCompletionRate;
      } else if (perf && perf.completionRate !== undefined && perf.completionRate !== null) {
        val = perf.completionRate;
      } else if (rec.completionRate !== undefined && rec.completionRate !== null) {
        val = rec.completionRate;
      } else {
        val = 0;
      }
      if (typeof val === 'string') {
        val = parseFloat(val.replace('%', ''));
        if (isNaN(val)) val = 0;
      }
      return val;
    },
    getPassingCompletionRateValue(row) {
      const val = this.getPassingCompletionRate(row);
      if (val > 1) {
        return Math.min(100, Math.max(0, Math.round(val)));
      }
      return Math.min(100, Math.max(0, Math.round(val * 100)));
    },
    getCompletionRate(row) {
      const rec = row.subscriptionRecord || row;
      const perf = rec.userPerformance || rec.performance;
      if (perf && perf.completionRate !== undefined) {
        return perf.completionRate;
      }
      if (rec.completionRate !== undefined) {
        return rec.completionRate;
      }
      return 0;
    },
    viewCoachingBookings(row) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const subId = this.$route.params.id || this.form.id;
      const userUuid = row.user.uuid || row.subscriptionRecord && row.subscriptionRecord.userUuid || row.userUuid;
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.bookingsList = [];
      this.bookingsLoading = true;
      this.dialogBookingsVisible = true;
      if (token && subId && userUuid) {
        (0, _subscriptions.getIndividualCoachingBookings)(token, subId, userUuid).then(response => {
          const bookings = response.data && response.data.rows || [];
          this.bookingsList = bookings;

          // Find all unique coach UUIDs we don't have in coachMap
          const uniqueCoaches = Array.from(new Set(bookings.map(b => b.coachUuid).filter(uuid => uuid && !this.coachMap[uuid])));

          // Query names for these coach UUIDs
          const coachPromises = uniqueCoaches.map(uuid => {
            return (0, _user.getUser)(token, uuid).then(userRes => {
              const name = (userRes.data.givenName || '') + ' ' + (userRes.data.familyName || '');
              this.$set(this.coachMap, uuid, name.trim() || 'Coach');
            }).catch(err => {
              (0, _log.showDebugLog)('getUser-coach-error', err);
              this.$set(this.coachMap, uuid, 'Coach (' + uuid.substring(0, 8) + ')');
            });
          });
          return Promise.all(coachPromises);
        }).then(() => {
          this.bookingsLoading = false;
        }).catch(error => {
          (0, _log.showDebugLog)('getIndividualCoachingBookings-error', error);
          this.bookingsLoading = false;
          (0, _log.displayPopupMessage)('Failed to load coaching bookings.', 'error');
        });
      } else {
        this.bookingsLoading = false;
        (0, _log.displayPopupMessage)('Missing booking identifier.', 'error');
      }
    },
    formatBookingTime(utcStr) {
      if (!utcStr) return '';
      const date = new Date(utcStr);
      const pad = num => String(num).padStart(2, '0');
      const YYYY = date.getFullYear();
      const MM = pad(date.getMonth() + 1);
      const DD = pad(date.getDate());
      const hh = pad(date.getHours());
      const mm = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    },
    getBookingStatusType(status) {
      switch (status) {
        case 'booked':
          return 'success';
        case 'open':
          return 'info';
        case 'cancelled':
          return 'danger';
        default:
          return 'warning';
      }
    },
    handleTabClick(tab) {
      const hash = tab.name === 'user-records' ? '#user-records' : '';
      if (this.$route.hash !== hash) {
        const p = this.$router.replace({
          hash
        });
        if (p && typeof p.catch === 'function') {
          p.catch(() => {});
        }
      }
    },
    loadUserRecordsStatistics() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const subId = this.$route.params.id || this.form.id;
      if (token && subId) {
        (0, _subscriptions.getSubscriptionStatistics)(token, subId).then(response => {
          if (response && response.data) {
            this.userRecordsStats = response.data.relatedHikesInfo || response.data.individualCoaching ? response.data : response.data.data || response.data;
          }
        }).catch(error => {
          (0, _log.showDebugLog)('getSubscriptionStatistics-error', error);
        });
      }
    }
  }
};